import useGetPathPickUsage from "@/features/pathpick/hooks/query/useGetPathPickUsage";
import { PATHPICK_USAGE_WARNING_THRESHOLD } from "@/features/pathpick/constants";

// 핫딜 한도(금액) 사용량 파생값 — 사용량 카드와, 모바일에서 카드를 대신하는
// "사용량 보기" 버튼이 공유한다. 경고 배지 판정이 두 곳으로 갈라지면 안 되므로
// 카드에 인라인으로 있던 계산을 그대로 여기로 옮겼다.
//
// 표시 분기는 멤버십 code가 아니라 usage 응답의 플래그(isAllowed / isUnlimited)로 판정한다.
const usePathPickStockOrderUsage = () => {
  const { pathPickUsage } = useGetPathPickUsage();
  const { stockOrder } = pathPickUsage;

  // 한도 소진은 접수 금액(orderedAmount) 기준 — confirmedAmount는 그 부분집합이라 더하지 않는다.
  const orderedAmount = stockOrder?.orderedAmount ?? 0;
  const confirmedAmount = stockOrder?.confirmedAmount ?? 0;
  const limit = stockOrder?.monthlyLimit ?? 0;
  const remaining = stockOrder?.remaining ?? Math.max(limit - orderedAmount, 0);
  const progress = limit > 0 ? Math.min((orderedAmount / limit) * 100, 100) : 0;

  const isAllowed = Boolean(stockOrder?.isAllowed);
  const isUnlimited = Boolean(stockOrder?.isUnlimited);
  // 한도 표시가 있는 경우(핫딜 허용 + 무제한 아님)에만 경고 판정이 의미 있다.
  const isLimited = isAllowed && !isUnlimited;
  const isNearLimit = isLimited && progress >= PATHPICK_USAGE_WARNING_THRESHOLD;

  // 경고 구간에서는 트랙까지 경고 톤으로 바꿔 바가 주황 단독으로 튀지 않게 한다.
  const progressFill = isNearLimit ? "#E8720C" : "#1272EF";
  const progressTrack = isNearLimit ? "#FFF7ED" : "#E5EDF4";

  return {
    orderedAmount,
    confirmedAmount,
    limit,
    remaining,
    progress,
    isAllowed,
    isUnlimited,
    isLimited,
    isNearLimit,
    progressFill,
    progressTrack,
  };
};

export default usePathPickStockOrderUsage;
